module.exports = __webpack_public_path__ + "assets/img/idea-icon.bd867a45.png";